export default "__VITE_ASSET__15875c8e__"